import { Chart } from '../Enums/Chart.enum';
import { HealthData } from '../Enums/HealthData.enum';
import { QuestionnaireItems } from '../Enums/QuestionnaireItems.enum';

export const CHARTS_DATASET = {
	[Chart.ACTUAL_WEIGHT]: {
		title: 'base.actualWeight',
		keys: [QuestionnaireItems.ACTUAL_WEIGHT],
	},
	[Chart.URINE_PROTEIN]: {
		title: 'base.urineProtein',
		keys: [QuestionnaireItems.URINE_PROTEIN],
	},
	[Chart.URINE_GLUCOSE]: {
		title: 'base.urineGlucose',
		keys: [QuestionnaireItems.URINE_GLUCOSE],
	},
	[Chart.URINE_BLOOD]: {
		title: 'base.urineBlood',
		keys: [QuestionnaireItems.URINE_BLOOD],
	},
	[Chart.BODY_TEMPERATURE]: {
		title: 'base.bodyTemperature',
		keys: [QuestionnaireItems.BODY_TEMPERATURE],
	},
	[Chart.EDEMAS]: {
		title: 'base.edemas',
		keys: [QuestionnaireItems.EDEMAS],
	},
	[Chart.ADDITIONAL_WEIGHT]: {
		title: 'base.additionalWeight',
		keys: [QuestionnaireItems.ADDITIONAL_WEIGHT],
	},
	[Chart.CTG]: {
		title: 'base.ctg',
		keys: [QuestionnaireItems.CTG],
	},
	[Chart.DIASTOLIC_BLOOD_PRESSURE]: {
		title: 'base.diastolicBloodPressure',
		keys: [QuestionnaireItems.DIASTOLIC_BLOOD_PRESSURE],
	},
	[Chart.SYSTOLIC_BLOOD_PRESSURE]: {
		title: 'base.systolicBloodPressure',
		keys: [QuestionnaireItems.SYSTOLIC_BLOOD_PRESSURE],
	},
	[Chart.TOTAL_NUMBER_OF_PREGNANCIES]: {
		title: 'base.totalNumberOfPregnancies',
		keys: [QuestionnaireItems.TOTAL_NUMBER_OF_PREGNANCIES],
	},
	[Chart.WEIGHT_BEFORE_PREGNANCY]: {
		title: 'base.weightBeforePregnancy',
		keys: [QuestionnaireItems.WEIGHT_BEFORE_PREGNANCY],
	},
	[Chart.BLOOD_GLUCOSE]: {
		title: 'base.glycemia',
		keys: [
			HealthData.BLOOD_GLUCOSE,
			HealthData.BLOOD_GLUCOSE_EXTRA,
			HealthData.BLOOD_GLUCOSE_FASTING,
			HealthData.BLOOD_GLUCOSE_BEFORE_BREAKFAST,
			HealthData.BLOOD_GLUCOSE_BEFORE_LUNCH,
			HealthData.BLOOD_GLUCOSE_BEFORE_DINNER,
			HealthData.BLOOD_GLUCOSE_AFTER_BREAKFAST,
			HealthData.BLOOD_GLUCOSE_AFTER_LUNCH,
			HealthData.BLOOD_GLUCOSE_AFTER_DINNER,
			HealthData.BLOOD_GLUCOSE_BEFORE_SLEEP,
			HealthData.BLOOD_GLUCOSE_BEFORE_WORKOUT,
			HealthData.BLOOD_GLUCOSE_3AM,
		],
	},
	[Chart.BLOOD_PRESSURE]: {
		title: 'component.chart.filter.bloodPressureAndHearthBeat',
		keys: [
			HealthData.BLOOD_PRESSURE_SYSTOLIC,
			HealthData.BLOOD_PRESSURE_DIASTOLIC,
			HealthData.HEARTH_RATE,
		],
	},
	[Chart.BLOOD_PRESSURE_SYS_DIA]: {
		title: 'component.chart.filter.bloodPressure',
		keys: [
			HealthData.BLOOD_PRESSURE_SYSTOLIC,
			HealthData.BLOOD_PRESSURE_DIASTOLIC,
		],
	},
	[Chart.WEIGHT]: {
		title: 'base.shared.form.weight.label2',
		keys: [HealthData.WEIGHT, QuestionnaireItems.WEIGHT_BEFORE_PREGNANCY],
	},
	[Chart.HEIGHT]: {
		title: 'component.chart.filter.height',
		keys: [HealthData.HEIGHT],
	},
	[Chart.WAISTLINE]: {
		title: 'base.waistline',
		keys: [HealthData.WAISTLINE],
	},
	[Chart.BREATHING_RATE]: {
		title: 'component.chart.filter.breathingRate',
		keys: [HealthData.BREATHING_RATE],
	},
	[Chart.STEPS]: {
		title: 'component.chart.filter.steps',
		keys: [HealthData.STEP_COUNT],
	},
	[Chart.SLEEP]: {
		title: 'component.chart.filter.sleep',
		keys: [HealthData.SLEEP],
	},
	[Chart.OXYGEN_SATURATION]: {
		title: 'component.chart.filter.oxygenSaturation',
		keys: [HealthData.OXYGEN_SATURATION],
	},
	[Chart.HEMOGLOBIN]: {
		title: 'component.chart.filter.hemoglobin',
		keys: [HealthData.HEMOGLOBIN],
	},
	[Chart.HEMOGLOBIN_A1C]: {
		title: 'component.chart.filter.hemoglobinA1C',
		keys: [HealthData.HEMOGLOBIN_A1C],
	},
	[Chart.STRESS_LEVEL]: {
		title: 'component.chart.filter.stressLevel',
		keys: [HealthData.STRESS_LEVEL],
	},
	[Chart.ACTIVE_ENERGY]: {
		title: 'component.chart.filter.activeEnergy',
		keys: [HealthData.ACTIVE_ENERGY],
	},
	[Chart.DISTANCE_WALKING_RUNNING]: {
		title: 'component.chart.filter.distanceWalkingRunning',
		keys: [HealthData.DISTANCE_WALKING_RUNNING],
	},
	[Chart.WORKOUT]: {
		title: 'component.chart.filter.workout',
		keys: [HealthData.WORKOUT],
	},
	[Chart.ESAS]: {
		title: 'ESAS',
		keys: [
			'esasCelkovapohoda',
			'esasBolest',
			'esasUnava',
			'esasOspalost',
			'esasNevolnost',
			'esasNechutenstvi',
			'esasDusnost',
			'esasDeprese',
			'esasUzkost',
			'esasJinyproblem',
			'psychoStrach,tisen,uzkost',
			'psychoDepresivita',
			'psychoZvladanisituace',
		],
	},
};
